import Vue from 'vue';

export default new Vue();



// WEBPACK FOOTER //
// ./pages/projects/labels/event_hub.js